import { effect, Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'privanot.darkMode';
const DARK_CLASS = 'dark';

@Injectable({ providedIn: 'root' })
export class DarkModeService {
    public readonly enabled = signal<boolean>(this.read());

    constructor() {
        effect(() => {
            const on = this.enabled();
            document.documentElement.classList.toggle(DARK_CLASS, on);
            try {
                localStorage.setItem(STORAGE_KEY, on ? '1' : '0');
            } catch {
                // localStorage unavailable (private mode, etc.) — silent fail is fine
            }
        });
    }

    public toggle(): void {
        this.enabled.update((v) => !v);
    }

    public setEnabled(value: boolean): void {
        this.enabled.set(value);
    }

    private read(): boolean {
        try {
            return localStorage.getItem(STORAGE_KEY) === '1';
        } catch {
            return false;
        }
    }
}
